import { createFileRoute, redirect } from '@tanstack/react-router';
import { headSignupSubRoute } from 'router/utils';

import {
  clearLeadStorage,
  clearOpportunityPendingLeadId,
  getOpportunityPendingLeadId,
  setOpportunityPendingLeadId,
} from 'config/storage';
import { searchOppQueryOptions } from 'services/partnersSelfSignup/opportunity';
import {
  readLeadQueryCache,
  resolveLeadQueryVariables,
} from 'services/partnersSelfSignup/signup';

const pollingConfig = {
  times: 10,
  everyInMs: 5000,
};

export const Route = createFileRoute('/opportunity/')({
  head: headSignupSubRoute,
  loader: async ({ context }) => {
    const { queryClient } = context;

    const variables = resolveLeadQueryVariables(queryClient);
    const lead = readLeadQueryCache(queryClient, variables);

    const leadId =
      lead?.lead.id ?? getOpportunityPendingLeadId(queryClient) ?? '';

    if (!leadId) {
      throw new Error('Lead ID is required to search for opportunity');
    }

    if (lead) {
      setOpportunityPendingLeadId(queryClient, leadId);
      clearLeadStorage(queryClient);
    }

    const response = await queryClient.fetchQuery(
      searchOppQueryOptions({
        leadId,
        options: {
          retry: pollingConfig.times,
          retryDelay: pollingConfig.everyInMs,
          staleTime: 0,
          validateResult: ({ success }) => {
            if (!success) {
              throw new Error('Opp ID not available yet');
            }
          },
        },
      }),
    );

    clearOpportunityPendingLeadId(queryClient);
    throw redirect({
      to: `/opportunity/$oppId/terms-and-conditions`,
      params: { oppId: response.id },
    });
  },
});
